import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PAYMENTS_URL } from '@webapp/core/config';
import { ButtonComponent, CardComponent, IconComponent, ToastService } from '@webapp/ui';

@Component({
  selector: 'app-link-success',
  imports: [ButtonComponent, CardComponent, IconComponent, RouterLink],
  templateUrl: './link-success.component.html',
  styleUrl: './link-success.component.scss',
})
export class LinkSuccessComponent {
  paymentsUrl = inject(PAYMENTS_URL);
  toastService = inject(ToastService);

  async paymentLink() {
    const localStorageLink = localStorage.getItem(
      'activar_policy_payment_link'
    );
    if (localStorageLink) {
      const token = JSON.parse(localStorageLink);
      const url = `${this.paymentsUrl}cotizacion/${token.tokenLink}`;
      try {
        await navigator.clipboard.writeText(url ?? '');
        this.toastService.showToast(
          'Link copiado',
          'El link de pago ha sido copiado al portapapeles',
          'success'
        );
      } catch (err) {
        console.error('Failed to copy link:', err);
        this.toastService.showToast(
          'Error',
          'No se pudo copiar el link',
          'error'
        );
      }
    }


  }
}
